<template>
  <div>
    <table class="hovertable elevation-6">
      <thead>
        <tr>
          <th>
            <div style="line-height:normal;">
              Documento
              <!-- <template v-if="tieneDocumentoObligatorio">
                <br>
                <em class="error--text font-weight-regular"><small>El asterisco (*) indica documento obligatorio</small></em>
              </template> -->
            </div>
          </th>
          <th>Archivo(s) cargados(s)</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in lstDocumento"
          :key="item.tipoDocumentoProcesoId"
        >
          <td>
            <section style="display:flex;align-items:center;">
              <div style="width:100%;">
                <div>
                  <strong
                    v-if="$docObligatorios.includes(item.criterioDominioId)"
                    class="error--text title"
                    title="Obligatorio"
                  >*</strong>
                  &nbsp;
                  <strong>{{ index+1 }}.</strong> {{ item.descripcionTipoDocumento.charAt(0).toUpperCase() + item.descripcionTipoDocumento.toLowerCase().slice(1) }}
                  &nbsp;
                  <span
                    v-if="$docObligatorios.includes(item.criterioDominioId)"
                    class="error--text font-weight-bold"
                  ><em>{{ $msjTipoObligatoriedad.obligatorio }}</em></span>
                  <span
                    v-if="$docObligatoriosSegunCorresponda.includes(item.criterioDominioId)"
                    class="warning--text font-weight-bold"
                  ><em>{{ $msjTipoObligatoriedad.corresponda }}</em></span>
                  <span
                    v-if="$docNoObligatorios.includes(item.criterioDominioId)"
                    class="grey--text text--darken-4 font-weight-bold"
                  ><em>{{ $msjTipoObligatoriedad.opcional }}</em></span>
                </div>
                <div class="text-xs-center">
                  <a
                    v-for=" plantilla in $plantillas.filter(r => r.tipoDocumentoProcesoId === item.tipoDocumentoProcesoId)"
                    :key="plantilla.tipoDocumentoProcesoId"
                    style="text-decoration:underline"
                    @click.stop="descargarPlantilla(plantilla.nombreArchivo)"
                  ><v-icon
                    size="13px"
                    color="primary"
                  >download</v-icon>&nbsp;{{ "Descargar "+plantilla.descripcion }}</a>
                </div>
              </div>
              <v-spacer />
              <GlobalCardToolTip
                v-if="$documentos_ayuda.map(i=>i.criterioDominioId).includes(item.criterioDominioId)"
                prepend-icon="info"
                icon-color="secondary"
                width="360px"
                icon-size="18px"
              >
                <template #contenido>
                  {{ $documentos_ayuda.find(i=>i.criterioDominioId === item.criterioDominioId).ayuda }}
                </template>
              </GlobalCardToolTip>
            </section>
          </td>
          <td>
            <div style="display:flex;flex-direction:column;gap:9px;font-size: 12px;">
              <v-layout
                v-for="(file, i) in item.documentoAdjuntoDetalle"
                :key="`${i}` - index"
                style="align-items:start;"
              >
                <div style="flex:1;">
                  <a
                    style="text-decoration: underline;word-break: break-word;"
                    @click="DescargarAdjunto(file)"
                  >{{ file.nombreArchivo }}</a><br>
                  <small
                    class="font-weight-black"
                  >({{ $fechas.FormatearFecha(file.fechaRegistro) }}) </small>
                </div>
                <v-icon
                  v-if="eliminarAdjuntos"
                  color="red"
                  style="float:right;cursor:pointer;"
                  small
                  @click="deleteFile(file, item, index)"
                >
                  delete
                </v-icon>
                <v-icon
                  v-else
                  color="red"
                  style="float:right;cursor:pointer;"
                  small
                  :click="deleteFile(file, item, index)"
                >
                  delete
                </v-icon>
              </v-layout>
            </div>
          </td>
          <td class="pa-0 td-customdropzone">
            <vue-dropzone
              v-if="item.documentoAdjuntoDetalle.length < 6"
              id="customdropzone"
              :ref="'myVueDropzone'+item.tipoDocumentoProcesoId"
              :options="configuracionDropZone(item, index)"
              :include-styling="false"
              :duplicate-check="true"
              :use-custom-slot="true"
              @vdropzone-file-added="vfileAdded(item, index)"
              @vdropzone-sending="sendingEvent(...arguments, item)"
              @vdropzone-success="successFile"
              @vdropzone-error="errorFile"
              @vdropzone-drag-over="vfileAdded(item, index)"
            >
              <v-layout
                class="dropzone-custom-content"
                style="align-items: center; justify-content: center; height: 100%;"
              >
                <v-icon color="black">
                  upload
                </v-icon>
                <span class="hide-on-movile">&nbsp;&nbsp;&nbsp;Haga click aquí o arrastre su(s) archivo(s)&nbsp;&nbsp;</span>
  
                <div v-if="filtraTipoArchivoValido(item).tipo.length<25">
                  {{ filtraTipoArchivoValido(item).tipo }}
                </div>
                <div v-else>
                  {{ filtraTipoArchivoValido(item).tipo.substring(0,10) }}...
                </div>
                <GlobalCardToolTip
                  v-if="filtraTipoArchivoValido(item).tipo.length > 25"
                  prepend-icon="info"
                  icon-color="amber"
                  width="360px"
                  icon-size="18px"
                >
                  <template #contenido>
                    <span v-html="filtraTipoArchivoValido(item).tipo" />
                  </template>
                </GlobalCardToolTip>
              </v-layout>
            </vue-dropzone>
            <div
              v-else
              class="error--text px-4 py-2"
            >
              <em>Solo se pueden subir {{ $contantesDropZone.cantidadMaximoArchivos }} archivos como máximo.</em>
            </div>
          </td>
        </tr>
      </tbody>
    </table>  
  </div>
</template>
    <script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import typesDocumentos from "@/store/types/SolicitudCredenciales";
    import typesUtils from "@/store/types/utils";
    import vueDropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import GlobalCardToolTip from "@/components/Global/GlobalCardToolTip.vue";
    
    
    export default {
      components: {
        vueDropzone,
        GlobalCardToolTip,
      },
      props: {
        acceptedFiles: {
          type: Array,
          default: ()=>[]
        },
        solicitudId: {
          type: Number,
          default: 0
        },
        criterio: {
          type: String,
          default: ''
        },
        eliminarAdjuntos: {
          type: Boolean,
          default: true
        }
      },
      data() {
        return {
          lstDocumento: [],
          dataDragAndDrop: true,
          headersFiles: [
            {
              sortable: false,
              text: "Nombre",
              value: "name"
            },
            {
              sortable: false,
              text: "Accion",
              value: ""
            }
          ],
          headers: [
            {
              text: "Tipo Documento",
              align: "left",
              sortable: false,
              value: "docType"
            },
            { text: "Archivo(s)", value: "files" },
            { text: "Acciones", value: "action" }
          ],
          filesAuxiliar: [],
        };
      },
      watch: {
        solicitudId(value) {
          this.cargar();
        }
      },
      mounted(){         
          this.cargar();
      },
    
      methods: {
        filtraTipoArchivoValido( idDatoAdjunto = 0){
            let cadena=''
            let tipoMime=''
            let tipoArchivo =this.acceptedFiles
    
            if(idDatoAdjunto.criterioDominioId!=0)
            {
              const datos = this.$docTipoExtensionPersonalizado.filter(ele=>ele.id ==idDatoAdjunto.criterioDominioId)
              if(datos.length>0){
                tipoArchivo = datos[0].tiposArchivo
              }else{
                tipoArchivo = this.acceptedFiles
              }
            }
            for(const tipoOficial of this.$uploadArchivosValidos){//MODIF
              for(const tipoArch of tipoArchivo){
                if(tipoOficial.type == tipoArch ){
                    cadena = cadena + tipoArch+" , "
                  tipoMime=tipoMime+tipoOficial.mimeType+" , "
                }
              }
    
            }
            if(cadena !=''){
              tipoMime=tipoMime.substring(0,tipoMime.length-2)
              cadena = cadena.substring(0,cadena.length-2).trim()
              cadena = "["+cadena+"]"
            }
            return {tipo:cadena,tipoMime: tipoMime}
        },
        configuracionDropZone(dato, indice){//*
          const archivosValidos = this.filtraTipoArchivoValido( dato)
    
          const dropOptions = {
            url: `${process.env.VUE_APP_API_AJAYU}credencial/documento_credencial/upload_archivo`, //
            maxFilesize: this.$contantesDropZone.tamanioMaximoArchivo, // MB //
            paramName: "pArchivos",
            acceptedFiles: archivosValidos.tipoMime,
            maxFiles: this.$contantesDropZone.cantidadMaximoArchivos,
            chunking: false,
            chunkSize: 500, // Bytes
            addRemoveLinks: true,
            createImageThumbnails: false,
            autoProcessQueue: true,
            parallelUploads: 1,
            //headers: {
              //Authorization: `Bearer ${localStorage.getItem("token")}`
            //}
          }
          return dropOptions
        },
        contarCatidadARchivosSubidos(){
          let cantidad=0
          for (const ele of this.lstDocumento){
            if(ele.documentoAdjuntoDetalle.length >0)
            {
              cantidad = cantidad +ele.documentoAdjuntoDetalle.length
            }
          }
          return cantidad
        },
        tieneRespaldo(){
          let tieneDocRespaldo=false
          for (const ele of this.lstDocumento){
            if(ele.documentoAdjuntoDetalle.length >0 && ele.descripcionTipoDocumento.toUpperCase().includes('RESPALDO'))
            {
              tieneDocRespaldo =true
              break
            }
          }
          return tieneDocRespaldo
        },
        cargar() {
          
          this.ListaDocumentosCredenciales({ solicitudId: this.solicitudId, criterio: this.criterio }).then(
            r => {
              this.lstDocumento = r.data.resultado;
              
              this.$emit("cantidadArchivos",this.contarCatidadARchivosSubidos())
              this.$emit("tieneRespaldo",this.tieneRespaldo())
            }
          );
        },
        addDocumentoAdjunto(item) {
          const objPost = {
            solicitudId: this.solicitudId,
            usuarioEmpresaId: this.$store.state.datosSession.usuarioEmpresaId,
            tipoDocumentoProcesoId: item.tipoDocumentoProcesoId,
            descripcion: item.descripcionTipoDocumento
          };
          if (!item.documentoAdjuntoId && this.dataDragAndDrop) {
            this.dataDragAndDrop = false;
            this.AdjuntarDocumentos(objPost).then(r => {
              item.documentoAdjuntoId = r.data.respuesta.documentoAdjuntoId;
              this.dataDragAndDrop = true;
            }).catch(err => {
              this.dataDragAndDrop = true;
            });
          }
        },
        async deleteFile(file, item, index) {
          this.SetDialogProgress(true);

          const payload = {
          id : file.documentoAdjuntoArchivoId,
          tokenAcceso : this.$route.params.codigo
          }

          await this.EliminarDocumentoCredenciales(payload).then(r => {

            if(r.status === 200){
            this.$cadenas.Mensaje("notificacion", "Mensaje", "Adjunto eliminado correctamente.", "success");
            } else if(r.status === 401){
            this.$cadenas.Mensaje("notificacion", "Mensaje", r.message, "error");
            } else {
            this.$cadenas.Mensaje("notificacion", "Mensaje", "Ocurrio un error al intentar eliminar el adjunto.", "error");
            }

            this.cargar();
            this.SetDialogProgress(false);
          });
          
          if(this.filesAuxiliar[file.documentoAdjuntoArchivoId]){
            this.$refs[`myVueDropzone${item.tipoDocumentoProcesoId}`][0].removeFile(this.filesAuxiliar[file.documentoAdjuntoArchivoId])
          }
          // this.filesAuxiliar.splice(file.documentoAdjuntoArchivoId, 1);
          // if (this.$refs[item.ref][0] != null)
          //   this.$refs[item.ref][0].removeAllFiles(true);

        },
        vfileAdded(item, index) {
        },
        sendingEvent(file, xhr, formData, item) {
          //formData.append("pDocumentoAdjuntoId", item.documentoAdjuntoId);
          this.SetDialogProgress(true);
          let objDoc = {
            documentoAdjuntoId: item.documentoAdjuntoId != null ? item.documentoAdjuntoId : 0,
            solicitudId: this.solicitudId,
            usuarioEmpresaId: this.$store.state.datosSession.usuarioEmpresaId,
            tipoDocumentoProcesoId: item.tipoDocumentoProcesoId,
            descripcion: item.descripcionTipoDocumento,
            numeroFojas: -1 // Exclusivo para trámite digital
          };
          formData.append("pDocumentoAdjunto", objDoc.documentoAdjuntoId + "|" + objDoc.solicitudId + "|" + "0"
            + "|" + objDoc.tipoDocumentoProcesoId + "|" + objDoc.descripcion + "|" + objDoc.numeroFojas);
        
          formData.append("tokenAcceso", this.$route.params.codigo)

        },
        successFile(file, response) {
          this.filesAuxiliar[response.id] = file
          this.cargar();
          this.SetDialogProgress(false);
          this.$cadenas.Mensaje('notificacion', 'Mensaje', 'Se adjuntó correctamente el archivo seleccionado.', 'success');
        },
        errorFile(file, response) {
          this.SetDialogProgress(false);
          if (file.size > this.$contantesDropZone.tamanioMaximoArchivo * 1024 * 1024) {
            this.$cadenas.Mensaje("notificacion", "Mensaje", "El tamaño del archivo supera al permitido (30 MB).", "error");
          } else {
            const mapRespuestasEspaniol = new Map();
            mapRespuestasEspaniol.set("You can not upload any more files.", `Solo se pueden subir ${ this.$contantesDropZone.cantidadMaximoArchivos} archivos como máximo.`);
            mapRespuestasEspaniol.set("You can't upload files of this type.", "No puede subir archivos de este tipo.");
            mapRespuestasEspaniol.set("El token JWT ha caducado", "El token JWT ha caducado.");
            if (response) {
              const mensaje = mapRespuestasEspaniol.get(response.message || response) || response;
              this.$cadenas.Mensaje("notificacion", "Mensaje", mensaje, "error");
              if(response.status === 'UNAUTHORIZED'){
                this.$router.push("/Login")
              }
            }
          }
          this.cargar();
        },
        DescargarAdjunto(pFile) {
          const payload = {
            pNombreArchivo: pFile.ruta + "/" + pFile.nombreArchivo,
            tokenAcceso: this.$route.params.codigo
          }
          this.ObtenerDocumentoAdjunto(payload).then(
            respuesta => {
              if(respuesta.status === 200 && respuesta.data){
                if (!window.navigator.msSaveOrOpenBlob) {
                  // BLOB NAVIGATOR
                  const url = window.URL.createObjectURL(new Blob([respuesta.data]));
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute("download", pFile.nombreArchivo);
                  document.body.appendChild(link);
                  link.click();
                } else {
                  // BLOB FOR EXPLORER 11
                  window.navigator.msSaveOrOpenBlob(
                    new Blob([respuesta.data]),
                    pFile.nombreArchivo
                  );
                }
                this.$cadenas.Mensaje('notificacion', 'Mensaje', 'Se descargó correctamente el archivo seleccionado.', 'success');
              } else {
                this.$cadenas.Mensaje('notificacion', 'Mensaje', 'No se pudo realizar la descarga del archivo seleccionado.', 'error');
              }
            }
          );
        },
        descargarPlantilla(nombreArchivo) {
          this.SetDialogProgress(true);
          let param = {
            pNombreArchivo:nombreArchivo,
            pSolicitudId:this.solicitudId
          }
          this.ObtenerDocumentoAdjuntoPlantillaV2(param)
            .then(r => {
              if (r.data != undefined) {
                let blob = new Blob([r.data], { type: "" });
                let link = document.createElement("a");
                link.download = nombreArchivo;
                link.href = window.URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click();
                this.SetDialogProgress(false);
              }
              else {
                this.SetDialogProgress(false);
                this.$cadenas.Mensaje('notificacion', 'Mensaje', 'No se encuentra el archivo', 'error');
              }
            });
        },
        getDocumentos() {
          return this.lstDocumento;
        },
        getDocumentosToRow() {
          return this.lstDocumento.reduce((result, doc) => {
    (doc.documentoAdjuntoDetalle || []).forEach(detalle => {
      result.push({
        documento: doc.descripcionTipoDocumento,
        nombre: detalle.nombreArchivo
      });
    });
    return result;
  }, []);
  
        },
        ...mapActions({
          ObtenerDocumentoAdjuntoPlantilla: typesDocumentos.actions.ObtenerDocumentoAdjuntoPlantilla,
          ListaDocumentosCredenciales: typesDocumentos.actions.ListaDocumentosCredenciales, //*
          AdjuntarDocumentos: typesDocumentos.actions.AdjuntarDocumentos,
          SubirDocumentosCredenciales: typesDocumentos.actions.SubirDocumentosCredenciales,//*
          EliminarDocumento: typesDocumentos.actions.EliminarDocumento,
          EliminarDocumentoCredenciales: typesDocumentos.actions.EliminarDocumentoCredenciales,//*
          ObtenerDocumentoAdjunto: typesDocumentos.actions.ObtenerDocumentoAdjunto,
          ObtenerDocumentoAdjuntoPlantillaV2: typesDocumentos.actions.ObtenerDocumentoAdjuntoPlantillaV2,
        }),
        ...mapMutations({
          SetDialogProgress: typesUtils.mutations.SetdialogProgress,          
        })
      },
      computed: {
        ...mapGetters({
          GetDocumentosCredenciales: typesDocumentos.getters.GetDocumentosCredenciales, //*

        }),
        tieneDocumentoObligatorio() {
          if (!this.lstDocumento || this.lstDocumento.length === 0) {
            return false;
          }
          return this.lstDocumento.some(item => this.$docObligatorios.includes(item.criterioDominioId));
        },
      }
    };
    </script>
  
 <style>
  .dz-preview {
    display: none;
  }
  
  #customdropzone {
    transition: background-color 0.2s linear;
    align-items: center;
    cursor: pointer;
    font-style: italic;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
  }
  
  #customdropzone .dz-message {
    height: 100%;
  }
  
  table.hovertable {
    max-width: 1200px;
    margin: auto;
    font-size: 0.9em;
    color: black;
    border-width: 1px;
    border-color: #999999;
    border-collapse: collapse;
    text-align: left;
  }
  
  table.hovertable th {
    border-width: 1px;
    font-size: 15px;
    padding: 10px;
    border-style: solid;
    border-color: #a9c6c9;
    text-align: center;
  }
  
  table.hovertable td {
    border-width: 1px;
    padding-inline: 14px;
    padding-block: 9px;
    border-style: solid;
    border-color: #a9c6c9;
    width: 33.3%;
  }
  table.hovertable tbody tr:hover {
    background-color: rgb(233, 233, 233)!important;
  }
  
  .td-customdropzone {
    background-color: #dcf3ff6b;
    border-style: dashed!important;
    border-color: steelblue!important;
    border-width: 2px!important;
    position: relative;
  }
  .td-customdropzone:hover {
    background-color: #dcf3ff;
  }
  
  </style>
<template>
  <div>
    <table class="hovertable elevation-6">
      <thead>
        <tr>
          <th>
            <div style="line-height:normal;">
              Documento
              <!-- <template v-if="tieneDocumentoObligatorio">
                <br>
                <em class="error--text font-weight-regular"><small>El asterisco (*) indica documento obligatorio</small></em>
              </template> -->
            </div>
          </th>
          <th>Archivo(s) cargados(s)</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in lstDocumento"
          :key="item.tipoDocumentoProcesoId"
        >
          <td>
            <section style="display:flex;align-items:center;">
              <div style="width:100%;">
                <div>
                  <strong
                    v-if="$docObligatorios.includes(item.criterioDominioId)"
                    class="error--text title"
                    title="Obligatorio"
                  >*</strong>
                  &nbsp;
                  <strong>{{ index+1 }}.</strong> {{ item.descripcionTipoDocumento.charAt(0).toUpperCase() + item.descripcionTipoDocumento.toLowerCase().slice(1) }}
                  &nbsp;
                  <span
                    v-if="$docObligatorios.includes(item.criterioDominioId)"
                    class="error--text font-weight-bold"
                  ><em>{{ $msjTipoObligatoriedad.obligatorio }}</em></span>
                  <span
                    v-if="$docObligatoriosSegunCorresponda.includes(item.criterioDominioId)"
                    class="warning--text font-weight-bold"
                  ><em>{{ $msjTipoObligatoriedad.corresponda }}</em></span>
                  <span
                    v-if="$docNoObligatorios.includes(item.criterioDominioId)"
                    class="grey--text text--darken-4 font-weight-bold"
                  ><em>{{ $msjTipoObligatoriedad.opcional }}</em></span>
                </div>
                <div class="text-xs-center">
                  <a
                    v-for=" plantilla in $plantillas.filter(r => r.tipoDocumentoProcesoId === item.tipoDocumentoProcesoId)"
                    :key="plantilla.tipoDocumentoProcesoId"
                    style="text-decoration:underline"
                    @click.stop="descargarPlantilla(plantilla.nombreArchivo)"
                  ><v-icon
                    size="13px"
                    color="primary"
                  >download</v-icon>&nbsp;{{ "Descargar "+plantilla.descripcion }}</a>
                </div>
              </div>
              <v-spacer />
              <GlobalCardToolTip
                v-if="$documentos_ayuda.map(i=>i.criterioDominioId).includes(item.criterioDominioId)"
                prepend-icon="info"
                icon-color="secondary"
                width="360px"
                icon-size="18px"
              >
                <template #contenido>
                  {{ $documentos_ayuda.find(i=>i.criterioDominioId === item.criterioDominioId).ayuda }}
                </template>
              </GlobalCardToolTip>
            </section>
          </td>
          <td>
            <div style="display:flex;flex-direction:column;gap:9px;font-size: 12px;">
              <v-layout
                v-for="(file, i) in item.documentoAdjuntoDetalle"
                :key="`${i}` - index"
                style="align-items:start;"
              >
                <div style="flex:1;">
                  <a
                    style="text-decoration: underline;word-break: break-word;"
                    @click="DescargarAdjunto(file)"
                  >{{ file.nombreArchivo }}</a><br>
                  <small
                    class="font-weight-black"
                  >({{ $fechas.FormatearFecha(file.fechaRegistro) }}) </small>
                </div>
                <v-icon
                  v-if="eliminarAdjuntos"
                  color="red"
                  style="float:right;cursor:pointer;"
                  small
                  @click="deleteFile(file, item, index)"
                >
                  delete
                </v-icon>
                <v-icon
                  v-else
                  color="red"
                  style="float:right;cursor:pointer;"
                  small
                  :click="deleteFile(file, item, index)"
                >
                  delete
                </v-icon>
              </v-layout>
            </div>
          </td>
          <td class="pa-0 td-customdropzone">
            <vue-dropzone
              :key="refreshKey"
              v-if="item.documentoAdjuntoDetalle.length < 6"
              id="customdropzone"
              :ref="'myVueDropzone'+item.tipoDocumentoProcesoId"
              :options="configuracionDropZone(item, index)"
              :include-styling="false"
              :duplicate-check="true"
              :use-custom-slot="true"
              @vdropzone-file-added="vfileAdded(item, index)"
              @vdropzone-sending="sendingEvent(...arguments, item)"
              @vdropzone-success="successFile"
              @vdropzone-error="errorFile"
              @vdropzone-drag-over="vfileAdded(item, index)"
            >
              <v-layout
                class="dropzone-custom-content"
                style="align-items: center; justify-content: center; height: 100%;"
              >
                <v-icon color="black">
                  upload
                </v-icon>
                <span class="hide-on-movile">&nbsp;&nbsp;&nbsp;Haga click aquí o arrastre su(s) archivo(s)&nbsp;&nbsp;</span>

                <div v-if="filtraTipoArchivoValido(item).tipo.length<25">
                  {{ filtraTipoArchivoValido(item).tipo }}
                </div>
                <div v-else>
                  {{ filtraTipoArchivoValido(item).tipo.substring(0,10) }}...
                </div>
                <GlobalCardToolTip
                  v-if="filtraTipoArchivoValido(item).tipo.length > 25"
                  prepend-icon="info"
                  icon-color="amber"
                  width="360px"
                  icon-size="18px"
                >
                  <template #contenido>
                    <span v-html="filtraTipoArchivoValido(item).tipo" />
                  </template>
                </GlobalCardToolTip>
              </v-layout>
            </vue-dropzone>
            <div
              v-else
              class="error--text px-4 py-2"
            >
              <em>Solo se pueden subir {{ $contantesDropZone.cantidadMaximoArchivos }} archivos como máximo.</em>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
    <script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import typesDocumentos from "@/store/types/SolicitudCredenciales";
    import typesUtils from "@/store/types/utils";
    import vueDropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import GlobalCardToolTip from "@/components/Global/GlobalCardToolTip.vue";


    export default {
      components: {
        vueDropzone,
        GlobalCardToolTip,
      },
      props: {
        acceptedFiles: {
          type: Array,
          default: ()=>[]
        },
        solicitudId: {
          type: Number,
          default: 0
        },
        criterio: {
          type: String,
          default: ''
        },
        eliminarAdjuntos: {
          type: Boolean,
          default: true
        }
      },
      data() {
        return {
          lstDocumento: [],
          dataDragAndDrop: true,
          headersFiles: [
            {
              sortable: false,
              text: "Nombre",
              value: "name"
            },
            {
              sortable: false,
              text: "Accion",
              value: ""
            }
          ],
          headers: [
            {
              text: "Tipo Documento",
              align: "left",
              sortable: false,
              value: "docType"
            },
            { text: "Archivo(s)", value: "files" },
            { text: "Acciones", value: "action" }
          ],
          filesAuxiliar: [],
          refreshKey: 223456189,
        };
      },
      watch: {
        solicitudId(value) {
          this.cargar();
        }
      },
      mounted(){//**************************************************************************************************************************************************************************

          this.cargar();
      },

      methods: {
        filtraTipoArchivoValido( idDatoAdjunto = 0){
            let cadena=''
            let tipoMime=''
            let tipoArchivo =this.acceptedFiles

            if(idDatoAdjunto.criterioDominioId!=0)
            {
              const datos = this.$docTipoExtensionPersonalizado.filter(ele=>ele.id ==idDatoAdjunto.criterioDominioId)
              if(datos.length>0){
                tipoArchivo = datos[0].tiposArchivo
              }else{
                tipoArchivo = this.acceptedFiles
              }
            }
            for(const tipoOficial of this.$uploadArchivosValidos){//MODIF
              for(const tipoArch of tipoArchivo){
                if(tipoOficial.type == tipoArch ){
                    cadena = cadena + tipoArch+" , "
                  tipoMime=tipoMime+tipoOficial.mimeType+" , "
                }
              }

            }
            if(cadena !=''){
              tipoMime=tipoMime.substring(0,tipoMime.length-2)
              cadena = cadena.substring(0,cadena.length-2).trim()
              cadena = "["+cadena+"]"
            }
            return {tipo:cadena,tipoMime: tipoMime}
        },
        configuracionDropZone(dato, indice){//*
          const archivosValidos = this.filtraTipoArchivoValido( dato)

          const dropOptions = {
            url: `${process.env.VUE_APP_API_AJAYU}credencial/documento_credencial/upload_archivo`, //
            maxFilesize: this.$contantesDropZone.tamanioMaximoArchivo, // MB //
            paramName: "pArchivos",
            acceptedFiles: archivosValidos.tipoMime,
            maxFiles: this.$contantesDropZone.cantidadMaximoArchivos,
            chunking: false,
            chunkSize: 500, // Bytes
            addRemoveLinks: true,
            createImageThumbnails: false,
            autoProcessQueue: true,
            parallelUploads: 1,
            //headers: {
              //Authorization: `Bearer ${localStorage.getItem("token")}`
            //}
          }
          return dropOptions
        },
        contarCatidadARchivosSubidos(){
          let cantidad=0
          for (const ele of this.lstDocumento){
            if(ele.documentoAdjuntoDetalle.length >0)
            {
              cantidad = cantidad +ele.documentoAdjuntoDetalle.length
            }
          }
          return cantidad
        },
        tieneRespaldo(){
          let tieneDocRespaldo=false
          for (const ele of this.lstDocumento){
            if(ele.documentoAdjuntoDetalle.length >0 && ele.descripcionTipoDocumento.toUpperCase().includes('RESPALDO'))
            {
              tieneDocRespaldo =true
              break
            }
          }
          return tieneDocRespaldo
        },
        cargar() {

          this.ListaDocumentosCredenciales({ solicitudId: this.solicitudId, criterio: this.criterio }).then(
            r => {
              this.lstDocumento = r.data.resultado;

              this.$emit("cantidadArchivos",this.contarCatidadARchivosSubidos())
              this.$emit("tieneRespaldo",this.tieneRespaldo())
            }
          );
        },
        addDocumentoAdjunto(item) {
          const objPost = {
            solicitudId: this.solicitudId,
            usuarioEmpresaId: this.$store.state.datosSession.usuarioEmpresaId,
            tipoDocumentoProcesoId: item.tipoDocumentoProcesoId,
            descripcion: item.descripcionTipoDocumento
          };
          if (!item.documentoAdjuntoId && this.dataDragAndDrop) {
            this.dataDragAndDrop = false;
            this.AdjuntarDocumentos(objPost).then(r => {
              item.documentoAdjuntoId = r.data.respuesta.documentoAdjuntoId;
              this.dataDragAndDrop = true;
            }).catch(err => {
              this.dataDragAndDrop = true;
            });
          }
        },
        async deleteFile(file, item, index) {
          this.SetDialogProgress(true);

          const payload = {
          id : file.documentoAdjuntoArchivoId,
          tokenAcceso : this.$route.params.codigo
          }

          await this.EliminarDocumentoCredenciales(payload).then(r => {

            if(r.status === 200){
            this.$cadenas.Mensaje("notificacion", "Mensaje", "Adjunto eliminado correctamente.", "success");
            } else if(r.status === 401){
            this.$cadenas.Mensaje("notificacion", "Mensaje", r.message, "error");
            } else {
            this.$cadenas.Mensaje("notificacion", "Mensaje", "Ocurrio un error al intentar eliminar el adjunto.", "error");
            }

            this.cargar();
            this.SetDialogProgress(false);
          });

          if(this.filesAuxiliar[file.documentoAdjuntoArchivoId]){
            this.$refs[`myVueDropzone${item.tipoDocumentoProcesoId}`][0].removeFile(this.filesAuxiliar[file.documentoAdjuntoArchivoId])
          }
          // this.filesAuxiliar.splice(file.documentoAdjuntoArchivoId, 1);
          // if (this.$refs[item.ref][0] != null)
          //   this.$refs[item.ref][0].removeAllFiles(true);

        },
        vfileAdded(item, index) {
        },
        sendingEvent(file, xhr, formData, item) {
          //formData.append("pDocumentoAdjuntoId", item.documentoAdjuntoId);
          this.SetDialogProgress(true);
          let objDoc = {
            documentoAdjuntoId: item.documentoAdjuntoId != null ? item.documentoAdjuntoId : 0,
            solicitudId: this.solicitudId,
            usuarioEmpresaId: this.$store.state.datosSession.usuarioEmpresaId,
            tipoDocumentoProcesoId: item.tipoDocumentoProcesoId,
            descripcion: item.descripcionTipoDocumento,
            numeroFojas: -1 // Exclusivo para trámite digital
          };
          formData.append("pDocumentoAdjunto", objDoc.documentoAdjuntoId + "|" + objDoc.solicitudId + "|" + "0"
            + "|" + objDoc.tipoDocumentoProcesoId + "|" + objDoc.descripcion + "|" + objDoc.numeroFojas);

          formData.append("tokenAcceso", this.$route.params.codigo)

        },
        successFile(file, response) {
          this.filesAuxiliar[response.id] = file
          this.cargar();
          this.SetDialogProgress(false);
          this.$cadenas.Mensaje('notificacion', 'Mensaje', 'Se adjuntó correctamente el archivo seleccionado.', 'success');
          this.refreshKey++
        },
        errorFile(file, response) {
          this.SetDialogProgress(false);
          if (file.size > this.$contantesDropZone.tamanioMaximoArchivo * 1024 * 1024) {
            this.$cadenas.Mensaje("notificacion", "Mensaje", "El tamaño del archivo supera al permitido (30 MB).", "error");
          } else {
            const mapRespuestasEspaniol = new Map();
            mapRespuestasEspaniol.set("You can not upload any more files.", `Solo se pueden subir ${ this.$contantesDropZone.cantidadMaximoArchivos} archivos como máximo.`);
            mapRespuestasEspaniol.set("You can't upload files of this type.", "No puede subir archivos de este tipo.");
            mapRespuestasEspaniol.set("El token JWT ha caducado", "El token JWT ha caducado.");
            if (response) {
              const mensaje = mapRespuestasEspaniol.get(response.message || response) || response;
              this.$cadenas.Mensaje("notificacion", "Mensaje", mensaje, "error");
              if(response.status === 'UNAUTHORIZED'){
                this.$router.push("/Login")
              }
            }
          }
          this.cargar();
        },
        DescargarAdjunto(pFile) {
          const payload = {
            pNombreArchivo: pFile.ruta + "/" + pFile.nombreArchivo,
            tokenAcceso: this.$route.params.codigo
          }
          this.ObtenerDocumentoAdjunto(payload).then(
            respuesta => {
              if(respuesta.status === 200 && respuesta.data){
                if (!window.navigator.msSaveOrOpenBlob) {
                  // BLOB NAVIGATOR
                  const url = window.URL.createObjectURL(new Blob([respuesta.data]));
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute("download", pFile.nombreArchivo);
                  document.body.appendChild(link);
                  link.click();
                } else {
                  // BLOB FOR EXPLORER 11
                  window.navigator.msSaveOrOpenBlob(
                    new Blob([respuesta.data]),
                    pFile.nombreArchivo
                  );
                }
                this.$cadenas.Mensaje('notificacion', 'Mensaje', 'Se descargó correctamente el archivo seleccionado.', 'success');
              } else {
                this.$cadenas.Mensaje('notificacion', 'Mensaje', 'No se pudo realizar la descarga del archivo seleccionado.', 'error');
              }
            }
          );
        },
        descargarPlantilla(nombreArchivo) {
          this.SetDialogProgress(true);
          let param = {
            pNombreArchivo:nombreArchivo,
            pSolicitudId:this.solicitudId
          }
          this.ObtenerDocumentoAdjuntoPlantillaV2(param)
            .then(r => {
              if (r.data != undefined) {
                let blob = new Blob([r.data], { type: "" });
                let link = document.createElement("a");
                link.download = nombreArchivo;
                link.href = window.URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click();
                this.SetDialogProgress(false);
              }
              else {
                this.SetDialogProgress(false);
                this.$cadenas.Mensaje('notificacion', 'Mensaje', 'No se encuentra el archivo', 'error');
              }
            });
        },
        getDocumentos() {
          return this.lstDocumento;
        },
        getDocumentosToRow() {
          return this.lstDocumento.reduce((result, doc) => {
    (doc.documentoAdjuntoDetalle || []).forEach(detalle => {
      result.push({
        documento: doc.descripcionTipoDocumento,
        nombre: detalle.nombreArchivo
      });
    });
    return result;
  }, []);

        },
        ...mapActions({
          ObtenerDocumentoAdjuntoPlantilla: typesDocumentos.actions.ObtenerDocumentoAdjuntoPlantilla,
          ListaDocumentosCredenciales: typesDocumentos.actions.ListaDocumentosCredenciales, //*
          AdjuntarDocumentos: typesDocumentos.actions.AdjuntarDocumentos,
          SubirDocumentosCredenciales: typesDocumentos.actions.SubirDocumentosCredenciales,//*
          EliminarDocumento: typesDocumentos.actions.EliminarDocumento,
          EliminarDocumentoCredenciales: typesDocumentos.actions.EliminarDocumentoCredenciales,//*
          ObtenerDocumentoAdjunto: typesDocumentos.actions.ObtenerDocumentoAdjunto,
          ObtenerDocumentoAdjuntoPlantillaV2: typesDocumentos.actions.ObtenerDocumentoAdjuntoPlantillaV2,
        }),
        ...mapMutations({
          SetDialogProgress: typesUtils.mutations.SetdialogProgress,
        })
      },
      computed: {
        ...mapGetters({
          GetDocumentosCredenciales: typesDocumentos.getters.GetDocumentosCredenciales, //*

        }),
        tieneDocumentoObligatorio() {
          if (!this.lstDocumento || this.lstDocumento.length === 0) {
            return false;
          }
          return this.lstDocumento.some(item => this.$docObligatorios.includes(item.criterioDominioId));
        },
      }
    };
    </script>

 <style>
  .dz-preview {
    display: none;
  }

  #customdropzone {
    transition: background-color 0.2s linear;
    align-items: center;
    cursor: pointer;
    font-style: italic;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
  }

  #customdropzone .dz-message {
    height: 100%;
  }

  table.hovertable {
    max-width: 1200px;
    margin: auto;
    font-size: 0.9em;
    color: black;
    border-width: 1px;
    border-color: #999999;
    border-collapse: collapse;
    text-align: left;
  }

  table.hovertable th {
    border-width: 1px;
    font-size: 15px;
    padding: 10px;
    border-style: solid;
    border-color: #a9c6c9;
    text-align: center;
  }

  table.hovertable td {
    border-width: 1px;
    padding-inline: 14px;
    padding-block: 9px;
    border-style: solid;
    border-color: #a9c6c9;
    width: 33.3%;
  }
  table.hovertable tbody tr:hover {
    background-color: rgb(233, 233, 233)!important;
  }

  .td-customdropzone {
    background-color: #dcf3ff6b;
    border-style: dashed!important;
    border-color: steelblue!important;
    border-width: 2px!important;
    position: relative;
  }
  .td-customdropzone:hover {
    background-color: #dcf3ff;
  }

  </style>
